import { gql } from "@apollo/client";

export const GENERATE_QUIZ_GROUP = gql`
  mutation generateQuizGroup(
    $schoolClass: ID!
    $name: String!
    $description: String!
    $dueDate: String!
    $payload: String
    $quizContext: String!
    $files: [Upload]
    $assignment: ID
    $quizGroup: ID
  ) {
    generateQuizGroup(
      schoolClass: $schoolClass
      name: $name
      description: $description
      dueDate: $dueDate
      payload: $payload
      quizContext: $quizContext
      files: $files
      assignment: $assignment
      quizGroup: $quizGroup
    ) {
      success
      message
      job {
        id
        message
      }
      quizGroup {
        id
      }
    }
  }
`;
export const PUBLISH_QUIZ_GROUP = gql`
  mutation publishQuizGroup($quizGroup: ID!) {
    publishQuizGroup(quizGroup: $quizGroup) {
      success
      message
    }
  }
`;

export const CREATE_OR_UPDATE_QUIZ_GROUP = gql`
  mutation createOrUpdateQuizGroup(
    $schoolClass: ID!
    $name: String!
    $description: String!
    $dueDate: String!
    $quizGroup: ID
    $quizContext: String
    $questions: [ID]!
  ) {
    createOrUpdateQuizGroup(
      schoolClass: $schoolClass
      name: $name
      description: $description
      dueDate: $dueDate
      quizGroup: $quizGroup
      quizContext: $quizContext
      questions: $questions
    ) {
      success
      message
      quizGroup {
        id
      }
    }
  }
`;

export const UPDATE_QUIZ_GROUP = gql`
  mutation updateQuizGroup(
    $quizGroup: ID!
    $dueDate: String!
    $tags: [String!]!
  ) {
    updateQuizGroup(quizGroup: $quizGroup, dueDate: $dueDate, tags: $tags) {
      success
      message
    }
  }
`;

export const GENERATE_QUIZ_UPLOAD_URL = gql`
  mutation ($quizGroup: ID!) {
    generateQuizGroupUploadUrl(quizGroup: $quizGroup) {
      success
      message
      url
    }
  }
`;

export const REMOVE_QUESTION_FROM_QUIZ_MUTATION = gql`
  mutation removeQuestionFromQuiz($quiz: ID!, $question: ID!) {
    removeQuestionFromQuiz(quiz: $quiz, question: $question) {
      success
      message
    }
  }
`;

export const VERIFY_QUIZ_GROUP_UPLOAD_TOKEN = gql`
  mutation ($user: ID!, $token: String!, $quizGroup: ID!) {
    verifyQuizGroupUploadToken(
      user: $user
      token: $token
      quizGroup: $quizGroup
    ) {
      success
      message
      isValid
      isIndependentUser
      quizGroup {
        id
        name
        schoolClass {
          students {
            ... on StudentNode {
              id
              studentIdentifier
              identifier
              yearGroup {
                yearGroup
              }
            }
            ... on StudentIdentifierNode {
              id
            }
          }
        }
        quizzes {
          id
          quizQuestions {
            id
            question {
              id
              questionText
              questionType
              options {
                id
                text
                isCorrect
              }
            }
          }
        }
      }
    }
  }
`;

export const SUBMIT_QUIZ_RESPONSE = gql`
  mutation submitQuizResponse($quiz: ID!, $identifier: ID, $payload: String!) {
    submitQuizResponse(
      quiz: $quiz
      identifier: $identifier
      payload: $payload
    ) {
      success
      message
    }
  }
`;
